import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { DOCUMENTS_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  communityId: string;
  parkDocId: string;
}

const mutateSubmitForApprovalDoc = async ({ communityId, parkDocId }: mutateProps) => {
  return await axiosAuth.post(`${DOCUMENTS_API(communityId)}/${parkDocId}/send-for-approval`);
};

const useSubmitForApprovalDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateSubmitForApprovalDoc,
    ...queryParams,
  });

export default useSubmitForApprovalDocMutation;
